module.exports = __webpack_public_path__ + "static/Image_Right@2x-dd7ea1cb836b7bc330af6ce726493cc5.png";